import { render, staticRenderFns } from "./exinfo.vue?vue&type=template&id=25624000&scoped=true&"
import script from "./exinfo.vue?vue&type=script&lang=js&"
export * from "./exinfo.vue?vue&type=script&lang=js&"
import style0 from "./exinfo.vue?vue&type=style&index=0&id=25624000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25624000",
  null
  
)

export default component.exports